import {
  Box,
  Typography,
  Button,
  Paper,
  TextField,
  Grid,
  InputAdornment,
  IconButton,
  Avatar,
  Divider,
  Chip,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useState, useEffect } from "react";
import { toast, Toaster } from "react-hot-toast";
import * as services from "../../services/services";
import IMG from "../../images/istockphoto.jpg";

const PetConnect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [currentPet, setCurrentPet] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [targetPet, setTargetPet] = useState(null);
  const [loading, setLoading] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState("none"); // none, pending, connected

  useEffect(() => {
    const fetchCurrentPet = async () => {
      try {
        const res = await services.getPetById(id);
        const petData = res.data.data;
        setCurrentPet(petData);

        // Check for existing link immediately
        if (petData?.hospitalPetCode) {
          try {
            const payload = {
              role: "HOSPITAL",
              hospitalId: String(petData.hospitalId),
              hospitalPetId: String(petData.hospitalPetCode),
            };
            const res_check = await services.checkPetLink(payload);
            const links = res_check.data.links;
            console.log(links)
            if (links && links.length > 0) {
              const link = links[0];
              const linkedBowPetId = link.ownerPetId;

              if (link.status === "PENDING") {
                setConnectionStatus("pending");
              } else if (link.status === "LINKED") {
                setConnectionStatus("connected");
              } else {
                setConnectionStatus("none");
              }

              // Fetch the linked target pet details to show the card
              if (linkedBowPetId) {
                setKeyword(linkedBowPetId)
                const res_bow = await services.getPetBowById(linkedBowPetId);
                if (res_bow.data) {
                  setTargetPet(res_bow.data);
                }
              }
            }
          } catch (linkError) {
            console.error("Error checking initial link status:", linkError);
          }
        }
      } catch (error) {
        console.error("Failed to fetch pet", error);
        toast.error("ไม่สามารถโหลดข้อมูลสัตว์เลี้ยงได้");
      }
    };
    fetchCurrentPet();
  }, [id]);

  const handleSearch = async () => {
    if (!keyword.trim()) return;
    setLoading(true);
    setTargetPet(null);
    setConnectionStatus("none"); // Reset status on new search

    try {
      // Mocking search results
      const res = await services.getPetBowById(keyword);
      if (res.data) {
        const foundPet = res.data;
        setTargetPet(foundPet);
        let payload = {
          role: "OWNER",
          ownerPetId: keyword,
        };
        // const res_check = await services.checkPetLink(payload);
        // if (res_check.data.links.length > 0) {
        //   if (res_check.data.links[0].hospitalPetId !== currentPet.hospitalPetCode) {
        //     setConnectionStatus("not_linked");
        //   }
        //   else {
        //     let link = res_check.data.links[0].status;
        //     if (link === "PENDING") {
        //       setConnectionStatus("pending");
        //     } else if (link === "LINKED") {
        //       setConnectionStatus("connected");
        //     }
        //   }

        // } else {
        setConnectionStatus("none");
        // }
      } else {
        toast.error("ไม่พบข้อมูลสัตว์เลี้ยง");
      }
    } catch (error) {
      console.error("Search failed", error);
      toast.error("ไม่พบข้อมูลสัตว์เลี้ยง");
    } finally {
      setLoading(false);
    }
  };

  const handleConnect = async () => {

    if (!targetPet) return;
    let payload = {
      role: "HOSPITAL",
      actorId: String(targetPet?.owners[0]?.id),
      ownerId: String(targetPet?.owners[0]?.id),
      ownerPetId: keyword,
      hospitalId: String(currentPet?.hospitalId),
      hospitalPetId: currentPet.hospitalPetCode,
    };

    console.log(payload)
    const res = await services.LinkPet(payload);

    toast.success("ส่งคำขอเชื่อมต่อสำเร็จ");
    setConnectionStatus("pending");
  };

  const PetCard = ({ pet, title }) => (
    <Paper sx={{ p: 3, maxWidth: 400, mx: "auto", mb: 4, height: "100%" }}>
      {title && (
        <Typography variant="h6" align="center" gutterBottom>
          {title}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Avatar
          src={pet.image || IMG}
          variant="rounded"
          sx={{ width: 100, height: 100 }}
        />
        <Box>
          <Typography variant="h6" fontWeight="bold">
            {pet.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {pet.type} | {pet.breed}
          </Typography>
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            Pet ID : <b>{pet.hospitalPetCode || pet.id}</b>
          </Typography>
          <Typography variant="caption" display="block">
            Microchip ID : <b>{pet.microchipNumber || "-"}</b>
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Typography variant="caption" color="text.secondary">
        เจ้าของ
      </Typography>
      <Typography variant="body2" fontWeight="bold">
        {pet.owner
          ? `${pet.owner.firstName} ${pet.owner.lastName}`
          : pet.ownerName || "ไม่ระบุ"}
      </Typography>
    </Paper>
  );
  const PetCard2 = ({ pet, title }) => (
    <Paper sx={{ p: 3, maxWidth: 400, mx: "auto", mb: 4, height: "100%" }}>
      {title && (
        <Typography variant="h6" align="center" gutterBottom>
          {title}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Avatar
          src={pet.image || IMG}
          variant="rounded"
          sx={{ width: 100, height: 100 }}
        />
        <Box>
          <Typography variant="h6" fontWeight="bold">
            {pet.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {pet.type} | {pet.breed}
          </Typography>
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            Pet ID : <b>{pet.hospitalPetCode || pet.id}</b>
          </Typography>
          <Typography variant="caption" display="block">
            Microchip ID : <b>{pet.microchip_number || "-"}</b>
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Typography variant="caption" color="text.secondary">
        เจ้าของ
      </Typography>
      <Typography variant="body2" fontWeight="bold">
        {pet.owners
          ? `${pet.owners[0].first_name} ${pet.owners[0].last_name}`
          : "ไม่ระบุ"}
      </Typography>
    </Paper>
  );
  const renderActionArea = () => {
    switch (connectionStatus) {
      case "connected":
        return (
          <Button
            variant="contained"
            size="large"
            startIcon={<CheckCircleIcon />}
            sx={{
              bgcolor: "#4CAF50", // Green
              "&:hover": { bgcolor: "#388E3C" },
              px: 6,
              py: 1.5,
              fontSize: "1rem",
              mb: 4,
              cursor: "default",
            }}
            disableRipple
          >
            เชื่อมต่อแล้ว
          </Button>
        );
      case "pending":
        return (
          <Button
            variant="contained"
            size="large"
            startIcon={<AccessTimeIcon />}
            sx={{
              bgcolor: "#9E9E9E", // Gray
              "&:hover": { bgcolor: "#9E9E9E" },
              px: 6,
              py: 1.5,
              fontSize: "1rem",
              mb: 4,
              cursor: "default",
            }}
            disableRipple
          >
            รอยืนยันการเชื่อมต่อ
          </Button>
        );
      case "not_linked":
        return (
          <Button
            variant="contained"
            size="large"
            startIcon={<CancelIcon />}
            sx={{
              bgcolor: "#ff9900ff", // Gray
              "&:hover": { bgcolor: "#ff9900ff" },
              px: 6,
              py: 1.5,
              fontSize: "1rem",
              mb: 4,
              cursor: "default",
            }}
            disableRipple
          >
            สัตว์เลี้ยงนี้ถูกเชื่อมต่อกับสัตว์เลี้ยงตัวอื่นแล้ว
          </Button>
        );
      case "none":
      default:
        return (
          <Button
            variant="contained"
            size="large"
            onClick={handleConnect}
            sx={{
              bgcolor: "#F57C00",
              "&:hover": { bgcolor: "#E65100" },
              px: 6,
              py: 1.5,
              fontSize: "1rem",
              mb: 4,
            }}
          >
            ขอเชื่อมต่อ
          </Button>
        );
    }
  };

  return (
    <>
      <Toaster />
      <AppBreadcrumbs />
      <Box
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Current Pet */}
        {currentPet && <PetCard pet={currentPet} />}

        {connectionStatus === "none" ? (
          <>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              ค้นหาสัตว์เลี้ยงที่ต้องการเชื่อมต่อ
            </Typography>

            <Box
              sx={{ display: "flex", gap: 1, mb: 1, maxWidth: 600, width: "100%" }}
            >
              <TextField
                fullWidth
                placeholder="ค้นหาจาก Bow Pet ID"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                InputProps={{
                  sx: { borderRadius: 1 },
                }}
                size="small"
              />
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#F57C00",
                  "&:hover": { bgcolor: "#E65100" },
                  minWidth: 50,
                  px: 2,
                }}
                onClick={handleSearch}
              >
                <SearchIcon />
              </Button>
              <IconButton aria-label="scan qr code">
                <QrCodeScannerIcon />
              </IconButton>
            </Box>
            <Typography
              variant="caption"
              color="primary"
              sx={{ mb: 4, display: "block", width: "100%", maxWidth: 600 }}
            >
              * พิมพ์ให้ถูกต้องทุกตัวอักษร ถึงจะแสดงผลการค้นหา
            </Typography>
          </>
        ) : (
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            กำลังเชื่อมต่อกับ
          </Typography>
        )}

        {/* Target Pet & Action */}
        {targetPet && (
          <>
            <PetCard2 pet={targetPet} />
            {renderActionArea()}
          </>
        )}

        <Box sx={{ maxWidth: 600, width: "100%", mt: 4 }}>
          <Typography variant="caption" display="block" paragraph>
            *เชื่อมต่อประวัติสุขภาพ เพื่อสร้าง ข้อมูล ประวัติการฉีดวัคซีน
            ประวัติการใช้ยาป้องกันเห็บหมัด ยาป้องกันพยาธิ อย่างสมบูรณ์ที่สุด
          </Typography>
          <Typography variant="subtitle2" fontWeight="bold">
            วิธีการคือ
          </Typography>
          <Typography variant="caption" component="div">
            1. ใช้ Pet ID หรือ Microchip ID จาก สัตว์เลี้ยงที่ต้องการ
            <br />
            2. ค้นหาสัตว์เลี้ยง
            <br />
            3. ตรวจสอบข้อมูลว่าเป็นสัตว์เลี้ยงที่ต้องการ ถ้าใช่กด "ขอเชื่อมต่อ"
            <br />
            4. ระบบจะส่ง แจ้งเตือนไปยังเจ้าของสัตว์เลี้ยง ให้ยอมรับการเชื่อมต่อ
            <br />
            5. เมื่อเจ้าของอีกฝั่ง ยอมรับการเชื่อมต่อ ข้อมูลจะเชื่อมต่อกัน
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default PetConnect;
